import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3dfdd64b"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Sell Token", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "---", -1))
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Bid Token", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "---", -1))
const _hoisted_6 = ["value"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Ends at", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Description", -1))
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.createAuction && _ctx.createAuction(...args)), ["prevent"]))
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.sellContract) = $event)),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createSellTokenClient && _ctx.createSellTokenClient(...args)))
    }, [
      _hoisted_2,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
        return (_openBlock(), _createElementBlock("option", {
          key: token.address,
          value: token.address
        }, _toDisplayString(token.symbol), 9, _hoisted_3))
      }), 128))
    ], 544), [
      [_vModelSelect, _ctx.form.sellContract]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Sell Amount",
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.sellAmount) = $event))
    }, null, 512), [
      [_vModelText, _ctx.form.sellAmount]
    ]),
    _hoisted_4,
    _withDirectives(_createElementVNode("select", {
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.bidContract) = $event))
    }, [
      _hoisted_5,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokens, (token) => {
        return (_openBlock(), _createElementBlock("option", {
          key: token.address,
          value: token.address
        }, _toDisplayString(token.symbol), 9, _hoisted_6))
      }), 128))
    ], 512), [
      [_vModelSelect, _ctx.form.bidContract]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: "Minimum Bid",
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.minimumBid) = $event))
    }, null, 512), [
      [_vModelText, _ctx.form.minimumBid]
    ]),
    _hoisted_7,
    _withDirectives(_createElementVNode("input", {
      type: "datetime-local",
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.endsAt) = $event))
    }, null, 512), [
      [_vModelText, _ctx.form.endsAt]
    ]),
    _hoisted_8,
    _withDirectives(_createElementVNode("textarea", {
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.description) = $event))
    }, null, 512), [
      [_vModelText, _ctx.form.description]
    ]),
    _createElementVNode("button", { disabled: _ctx.loading }, "Create Auction", 8, _hoisted_9)
  ], 32))
}